import React, { useEffect, useState } from 'react'
import NewUserHeader from '@Scenes/NewUserScene/NewUserHeader'
import './index.scss'
import SongwriterMusicProfessionalSelect from '@Scenes/NewUserScene/SongwriterMusicProfessionalSelect'
import NewMemberQuestions from '@Scenes/NewUserScene/NewMemberQuestions'
import NewSongwriterQuestions from '@Scenes/NewUserScene/NewSongwriterQuestions'
import ModalPortal from '@Components/Popups/ModalPortal'
import SelfPublisherSongwriterPopup from '@Components/Popups/SelfPublisherSongwriterPopup'

const NewUserScene = () => {
    const [step, setStep] = useState<string>('start')
    const [memberRedirectPopup, setMemberRedirectPopup] = useState<boolean>(false)

    useEffect(() => {
        window.scrollTo({
            top: 90,
            behavior: 'smooth',
        })
    }, [step])

    const renderCurrentStep = () => {
        switch (step) {
            case 'start':
                return <SongwriterMusicProfessionalSelect setStepState={(newStep) => setStep(newStep)} />
            case 'member':
                return <NewMemberQuestions />
            case 'songwriter':
                return <NewSongwriterQuestions openMemberRedirectPopup={() => setMemberRedirectPopup(true)} />
            default:
                return <SongwriterMusicProfessionalSelect setStepState={(newStep) => setStep(newStep)} />
        }
    }
    return (
        <>
            <title>New User</title>
            <main className="new-user-scene">
                <div className="global-container">
                    <div className="new-user-scene-wrapper">
                        <NewUserHeader />
                        {renderCurrentStep()}
                    </div>
                    <ModalPortal isOpen={memberRedirectPopup}>
                        <SelfPublisherSongwriterPopup onClose={() => setMemberRedirectPopup(false)} />
                    </ModalPortal>
                </div>
            </main>
        </>
    )
}

export default NewUserScene
